type FooterProps = Record<string, never>;

export function Footer(_props: FooterProps) {
  return <footer className="footer"></footer>;
}
